const navLinks = [
  { text: 'HOME', href: '#home' },
  { text: 'ABOUT', href: '#about' },
  { text: 'SKILLS', href: '#skills' },
  { text: 'PROJECTS', href: '#projects' },
  { text: 'CONTACTS', href: '#contacts' },
];

export const Navbar = () => {
  return (
    <nav id='navbar' className='navbar navbar-expand-md fixed-top'>
      <button
        id='togglerbutton'
        className='navbar-toggler ms-2 mt-1'
        type='button'
        data-bs-toggle='collapse'
        data-bs-target='#navbarSupportedContent'
        aria-controls='navbarSupportedContent'
        aria-label='Toggle navigation'
      >
        <span className='navbar-toggler-icon' style={{ backgroundImage: 'url("/images/burger-menu.svg")' }}></span>
      </button>

      <a className='navbar-brand' href='#home'>
        <div className='logoFont ms-2'>Ahmed Arafa</div>
      </a>
      <div
        className='collapse navbar-collapse justify-content-end me-5'
        id='navbarSupportedContent'
      >
        <ul className='nav nav-pills navbar-nav'>
          {navLinks.map((link) => (
            <li className='nav-item' key={link.href}>
              <a className='nav-link ps-2' href={link.href}>
                {link.text}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  )
}
